import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 5,
  class: "rounded-xl border-dashed border-2 border-blue-500"
}
const _hoisted_2 = {
  class: "text-center",
  style: { marginTop: '-0.75rem' }
}
const _hoisted_3 = { class: "bg-white text-blue-500 font-bold px-2 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentCourseConfirm = _resolveComponent("ContentCourseConfirm")!
  const _component_ContentStoreSelect = _resolveComponent("ContentStoreSelect")!
  const _component_ContentTieUpConfirm = _resolveComponent("ContentTieUpConfirm")!
  const _component_ContentOffHourStore = _resolveComponent("ContentOffHourStore")!
  const _component_OffHourNationalShipping = _resolveComponent("OffHourNationalShipping")!
  const _component_Content = _resolveComponent("Content")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.keyName === 'course_confirm')
      ? (_openBlock(), _createBlock(_component_ContentCourseConfirm, { key: 0 }))
      : (_ctx.keyName === 'store_select')
        ? (_openBlock(), _createBlock(_component_ContentStoreSelect, { key: 1 }))
        : (_ctx.keyName.startsWith('tie_up_confirm_'))
          ? (_openBlock(), _createBlock(_component_ContentTieUpConfirm, {
              key: 2,
              contents: _ctx.contents,
              "custom-id": _ctx.keyName.slice('tie_up_confirm_'.length)
            }, null, 8, ["contents", "custom-id"]))
          : (_ctx.keyName === 'off_hour_store')
            ? (_openBlock(), _createBlock(_component_ContentOffHourStore, { key: 3 }))
            : (_ctx.keyName === 'off_hour_national_shipping')
              ? (_openBlock(), _createBlock(_component_OffHourNationalShipping, {
                  key: 4,
                  contents: _ctx.contents
                }, null, 8, ["contents"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, " このコンテンツは未実装（キー名: " + _toDisplayString(_ctx.keyName || '（未設定）') + "） ", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
                    return (_openBlock(), _createBlock(_component_Content, {
                      key: index,
                      content: content
                    }, null, 8, ["content"]))
                  }), 128))
                ]))
  ]))
}